import React from "react";
import { num, dash, pct } from "../utils/formatters";
import { LANC_MES, BLOCOS_MANUAIS } from "../mockDataSemanal";
import BreakdownTable from "./BreakdownTable";

const sum = (a) => a.reduce((s, x) => s + x, 0);

/**
 * Aba "Resumo dos lançamentos" — grades de apoio do mês consolidado:
 * resumo por semana + matriz de lançamentos manuais + breakdown do mês.
 */
export default function ResumoLancamentos({ mes, periodos, nomes, ranges }) {
  const L = LANC_MES;
  const MT = mes.total;
  const WS = sum(periodos.map((p) => p.total));
  const LANC = MT - WS;

  return (
    <>
      <div className="panel-card">
        <div className="panel-head">
          <div>
            <h5>Resumo por semana</h5>
            <p className="panel-sub">
              Faturamento bruto, devoluções e tributos de cada semana, e a soma do mês.
            </p>
          </div>
        </div>
        <div className="tablewrap">
          <table className="apura-table">
            <thead>
              <tr>
                <th>Período</th>
                <th className="r">Faturamento bruto</th>
                <th className="r">Devoluções</th>
                <th className="r">Tributos a recolher</th>
                <th className="r">% do mês</th>
              </tr>
            </thead>
            <tbody>
              {periodos.map((m, i) => (
                <tr key={i}>
                  <td>
                    {nomes[i]}
                    <span className="sub2">{ranges[i]}</span>
                  </td>
                  <td className="r">{num(m.bruto)}</td>
                  <td className="r">{num(m.dev)}</td>
                  <td className={`r ${m.total < 0 ? "neg" : ""}`}>
                    {num(m.total)}
                    {m.total < 0 && " (credor)"}
                  </td>
                  <td className="r">{MT ? pct(m.total / MT) : "–"}</td>
                </tr>
              ))}
              <tr>
                <td>
                  Lançamentos do mês
                  <span className="sub2">sem data</span>
                </td>
                <td className="r">{num(L.servicos)}</td>
                <td className="r">–</td>
                <td className="r">{num(LANC)}</td>
                <td className="r">{MT ? pct(LANC / MT) : "–"}</td>
              </tr>
              <tr className="row-total">
                <td>Mês consolidado</td>
                <td className="r">{num(mes.bruto)}</td>
                <td className="r">{num(mes.dev)}</td>
                <td className="r res">{num(MT)}</td>
                <td className="r">100,0%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="panel-card">
        <div className="panel-head">
          <div>
            <h5>Lançamentos manuais por semana</h5>
            <p className="panel-sub">
              Efeito de cada bloco da planilha no total a recolher. Valor
              positivo aumenta o total, negativo reduz. Preencha nas abas das semanas.
            </p>
          </div>
        </div>
        <div className="tablewrap">
          <table className="apura-table">
            <thead>
              <tr>
                <th>Bloco</th>
                {nomes.slice(0, periodos.length).map((n) => (
                  <th key={n} className="r">{n}</th>
                ))}
                <th className="r">Mês</th>
              </tr>
            </thead>
            <tbody>
              {BLOCOS_MANUAIS.map((b) => (
                <tr key={b.id}>
                  <td>{b.titulo}</td>
                  {periodos.map((p, i) => {
                    const d = p.eff.porBloco[b.id];
                    return (
                      <td key={i} className={`r ${Math.abs(d) > 0.005 ? "man" : ""}`}>
                        {dash(d)}
                      </td>
                    );
                  })}
                  <td className="r res">{dash(mes.eff.porBloco[b.id])}</td>
                </tr>
              ))}
              <tr className="row-total">
                <td>Total dos lançamentos manuais</td>
                {periodos.map((p, i) => (
                  <td key={i} className="r">{dash(p.eff.total)}</td>
                ))}
                <td className="r res">{dash(mes.eff.total)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <BreakdownTable p={mes} isMes />
    </>
  );
}
